import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_stripe_pricing_table = _resolveComponent("stripe-pricing-table")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    fluid: "",
    class: "pt-16"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_stripe_pricing_table, {
        "pricing-table-id": _ctx.stripePricingTableId,
        "publishable-key": _ctx.stripePublishableKey
      }, null, 8, ["pricing-table-id", "publishable-key"])
    ]),
    _: 1
  }))
}